const TRACK_API = "https://hul-services.enscommerce.in/horlicks-protein/order-track/delhivery/v2/track";

// track-order.css mein step ke "active" hone ki jo class hai wahi likhiye
const ACTIVE_CLASS = "completed";

// Do ya zyada shipments hon aur API se type na aaye to ye naam lagte hain (order ke hisaab se).
// Pakka karne ke liye backend se har item ke saath "type" bhejwaiye: "product" ya "shaker".
const FALLBACK_LABELS = ["Free Shaker", "Your Product"];

// Screen par cards ka order: pehle "Your Product", uske neeche "Free Shaker"
const LABEL_ORDER = ["Your Product", "Free Shaker"];

const cancelledMessage = () =>
  "This order has been cancelled.";

// Order nahi mila wala message (HTML, taaki line breaks aur links chalein)
const NOT_FOUND_HTML = `We couldn't find that order.<br>
Please check your Order ID or AWB number and try again.<br><br>
Need help? Contact our support team - You can also reach the Horlicks Protein team by email at
<a href="mailto:information@horlicks.in">information@horlicks.in</a> or call the toll-free number
<a href="tel:18002035544">1800-203-5544</a>, all days between 9 AM and 6 PM.`;


// Liquid wale ek .MainTrackOrder card ka template (pehli baar click par ban jata hai)
let cardTemplate = null;

function getCardTemplate() {

  if (cardTemplate) return cardTemplate;

  const tpl = document.querySelector(".trackOrder .MainTrackOrder");

  if (!tpl) return null;

  cardTemplate = tpl.cloneNode(true);

  // Duplicate id se bachne ke liye id ko data-field bana do
  cardTemplate.querySelectorAll("[id^='js-']").forEach(el => {
    el.dataset.field = el.id;
    el.removeAttribute("id");
  });

  // Sirf awb_0 block use hota hai
  cardTemplate.querySelectorAll(".awb_1, .awb_2, .awb_3").forEach(el => el.remove());

  return cardTemplate;

}


document.addEventListener("click", function (e) {

  if (!e.target.closest(".track_order_btn")) return;

  const input = document.getElementById("track-order-no");
  const trackid = input.value.trim().toUpperCase();

  if (!trackid) {
    input.style.border = "1px solid red";
    return;
  }

  input.style.border = "";

  const loader = document.querySelector(".before_loader-gif");
  const result = document.querySelector(".trackOrder");
  const incorrect = document.querySelector(".IncorrectTrackOrder");
  const noTrack = document.querySelector(".no-trackOrder");

  const template = getCardTemplate();

  if (!loader || !result || !incorrect || !template) {
    console.warn("Track order: required elements missing", { loader, result, incorrect, template });
    return;
  }

  loader.style.display = "block";
  result.style.display = "none";
  incorrect.style.display = "none";
  if (noTrack) noTrack.style.display = "none";

  // GET par Content-Type header nahi bhejte, warna browser CORS preflight bhejta hai
  fetch(`${TRACK_API}?waybill=${encodeURIComponent(trackid)}`, {
    method: "GET"
  })

    .then(res => res.json())

    .then(data => {

      loader.style.display = "none";

      const plainId = trackid.replace(/^#/, "");

      const displayId = /^\d+$/.test(plainId)
        ? plainId
        : "#" + plainId;

      // v2: data.data = [ {success, waybillNo, deliverypartner, data: {...}}, ... ]
      // Purana object shape bhi chalega
      const items = Array.isArray(data?.data)
        ? data.data
        : (data?.data ? [{ success: data.success, data: data.data }] : []);

      const groups = [];

      items.forEach((item, index) => {

        if (!item || item.success === false) return;

        const d = item.data || {};
        const label = getLabel(item, index, items.length);
        const shipment = normalizeShipment(d);

        // Shipped: poora tracking card
        if (shipment) {
          groups.push(wrapGroup(buildShipmentCard(template, shipment, displayId), label));
          return;
        }

        // Shipment nahi mili: order ka status dekho
        const apiStatus = String(d.status || "").toUpperCase();

        // Order confirmed, abhi ship nahi hua: sirf "Order Confirmed" step highlight
        if (apiStatus === "IN_PROGRESS") {
          groups.push(wrapGroup(buildConfirmedCard(template, displayId), label));
          return;
        }

        // Cancelled order
        if (apiStatus === "CANCELLED") {
          groups.push(wrapGroup(buildMessageCard(displayId, cancelledMessage()), label));
        }

      });

      // Koi bhi shipment ya status nahi mila
      if (!groups.length) {
        showIncorrect();
        return;
      }

      // Label ke hisaab se sort karo: Your Product upar, Free Shaker neeche
      const rank = g => {
        const i = LABEL_ORDER.indexOf(g.dataset.label);
        return i === -1 ? LABEL_ORDER.length : i;
      };
      groups.sort((a, b) => rank(a) - rank(b));

      result.innerHTML = "";
      groups.forEach(g => result.appendChild(g));
      result.style.display = "block";

    })

    .catch(err => {

      console.error(err);

      loader.style.display = "none";

      showIncorrect("Something went wrong. Please try again.");

    });

});


// Shiprocket aur Delhivery dono ko ek jaisa shape deta hai
function normalizeShipment(d) {

  // Shiprocket response
  const sr = d?.tracking_data?.shipment_track?.[0];

  if (sr) {
    return {
      awb: sr.awb_code,
      courier: sr.courier_name,
      status: sr.current_status,
      edd: sr.edd
    };
  }

  // Delhivery response
  const dl = d?.ShipmentData?.[0]?.Shipment;

  if (dl) {
    return {
      awb: dl.AWB,
      courier: dl.SenderName,
      status: dl.Status?.Status,
      edd: dl.ExpectedDeliveryDate
    };
  }

  return null;

}


// Label: "Your Product" ya "Free Shaker" (sirf tab jab 2 ya zyada shipments hon)
function getLabel(item, index, total) {

  if (total < 2) return "";

  const raw = String(item.type || item.label || item.shipmentType || "").trim();

  if (/shaker/i.test(raw)) return "Free Shaker";
  if (/product/i.test(raw)) return "Your Product";
  if (raw) return raw;

  return FALLBACK_LABELS[index] || `Shipment ${index + 1}`;

}


// "2026-11-05 20:27:30" (Shiprocket) Safari mein parse nahi hota, isliye space ko T banate hain
function formatDate(value) {

  if (!value) return "";

  const d = new Date(String(value).replace(" ", "T"));

  if (isNaN(d)) return "";

  return d.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric"
  });

}


// Card ke andar data-field wale elements ka text set karo
function setFields(card, map) {

  Object.keys(map).forEach(field => {
    card.querySelectorAll(`[data-field="${field}"]`).forEach(el => {
      el.textContent = map[field];
    });
  });

}


// Shipped shipment ka tracking card
function buildShipmentCard(template, shipment, displayId) {

  const card = template.cloneNode(true);

  const dateText = formatDate(shipment.edd);

  setFields(card, {
    "js-tracking_id": displayId,
    "js-courier_awb": shipment.awb || "",
    "js-courier_name": shipment.courier || "",
    "js-tracking_status": shipment.status || "",
    "js-expected_delivery": dateText
  });

  card.querySelectorAll(".js-expected_delivery").forEach(el => {
    el.style.display = dateText ? "" : "none";
  });

  activateSteps(card, shipment.status || "");

  return card;

}


// Order confirmed par card: sirf pehla step highlight, AWB/courier/date chhupe hue
function buildConfirmedCard(template, displayId) {

  const card = template.cloneNode(true);

  setFields(card, {
    "js-tracking_id": displayId,
    "js-tracking_status": "Order Confirmed"
  });

  ["js-courier_awb", "js-courier_name", "js-expected_delivery"].forEach(field => {
    card.querySelectorAll(`[data-field="${field}"]`).forEach(el => {
      if (el.parentElement) el.parentElement.style.display = "none";
    });
  });

  activateSteps(card, "");

  return card;

}


// Sirf message wala card (cancelled)
function buildMessageCard(displayId, message) {

  const card = document.createElement("div");
  card.className = "MainTrackOrder";

  const head = document.createElement("div");
  head.className = "track-head";

  const label = document.createElement("span");
  label.className = "text-uppercase";
  label.textContent = "Tracking Order No - ";

  const value = document.createElement("span");
  value.className = "text-medium";
  value.textContent = displayId;

  head.appendChild(label);
  head.appendChild(value);

  const body = document.createElement("div");
  body.className = "no-track-order-discription";
  body.textContent = message;

  card.appendChild(head);
  card.appendChild(body);

  return card;

}


// Card ke upar label laga kar group banao
function wrapGroup(card, label) {

  const group = document.createElement("div");
  group.className = "shipment_group";
  group.dataset.label = label || "";

  if (label) {
    const h = document.createElement("h3");
    h.className = "shipment_label";
    h.textContent = label;
    group.appendChild(h);
  }

  group.appendChild(card);

  return group;

}


// Incorrect / error message dikhao
function showIncorrect(message) {

  const el = document.getElementById("incorrect-status");

  if (message) {
    el.textContent = message;       // custom message (safe, plain text)
  } else {
    el.innerHTML = NOT_FOUND_HTML;  // order nahi mila wala poora message
  }

  document.querySelector(".IncorrectTrackOrder").style.display = "block";

}


// Ek card ke steps activate karo
function activateSteps(card, rawStatus) {

  const status = rawStatus.toLowerCase();

  const block = card.querySelector(".awb_0");

  if (!block) return;

  const step = key =>
    block.querySelector(`[data-status="${key}"]`);

  const rto = step("RTO");

  if (rto) {
    rto.style.display = "none";
  }

  const isRto =
    status.includes("rto") ||
    status.includes("return");

  const isDelivered =
    status.includes("delivered") &&
    !status.includes("undelivered") &&
    !isRto;

  // Delhivery "Dispatched" bhi out for delivery hota hai
  const isOut =
    status.includes("out for delivery") ||
    status.includes("dispatched");

  const isTransit =
    isOut ||
    isDelivered ||
    isRto ||
    status.includes("transit") ||
    status.includes("shipped") ||
    status.includes("picked up");

  // Confirmed (hamesha active)
  step("confirmed")?.classList.add(ACTIVE_CLASS);

  // In Transit
  if (isTransit) {
    step("INTRANSIT")?.classList.add(ACTIVE_CLASS);
  }

  // Out for Delivery
  if (isOut || isDelivered) {
    step("OUTFORDELIVERY")?.classList.add(ACTIVE_CLASS);
  }

  // Delivered
  if (isDelivered) {
    step("SHIPMENTDELIVERED")?.classList.add(ACTIVE_CLASS);
  }

  // RTO
  if (isRto && rto) {
    rto.style.display = "block";
    rto.classList.add(ACTIVE_CLASS);
  }

}
